import { networkService } from "services/networkService";
import {
  METHOD_VRO_PLUGIN_LIST,
  METHOD_VRO_PLUGIN_CREATE,
  METHOD_VRO_PLUGIN_UPDATE,
  METHOD_VRO_PLUGIN_DELETE,
  METHOD_VRO_PLUGIN_DETAIL,
} from "constants/admin/masters/vro";
class VROPluginService {
  getAll = (data) => {
    return networkService
      .post(METHOD_VRO_PLUGIN_LIST, data)
      .then((response) => response.data);
  };
  getDetail = (id) => {
    const updatedMethodName = METHOD_VRO_PLUGIN_DETAIL.replace("{ID}", id);
    return networkService
      .get(updatedMethodName)
      .then((response) => response.data);
  };
  create = (data) => {
    return networkService
      .post(METHOD_VRO_PLUGIN_CREATE, data)
      .then((response) => response.data);
  };
  update = (data, id) => {
    const updatedMethodName = METHOD_VRO_PLUGIN_UPDATE.replace("{ID}", id);
    return networkService
      .post(updatedMethodName, data)
      .then((response) => response.data);
  };
  delete = (id,is_delete=false) => {
    const updatedMethodName = METHOD_VRO_PLUGIN_DELETE.replace("{ID}", id);
    return networkService
      .delete(updatedMethodName,{ data: { is_delete }})
      .then((response) => response.data);
  };
}
export default VROPluginService;
